import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const AddressDk = React.lazy(() => import('../components/address-dk'));

export default function (dependencies) {
  const { language } = dependencies;

  const html = (props) => {
    const LazyComponent = withLazyComponent(AddressDk);
    return LazyComponent({ ...props, ...dependencies });
  };

  return {
    html,
    validators: [(state) => (state.isMatched ? false : language['address-invalid'])],
    config: {
      behaviour: 'text-input',
    },
  };
}
